import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectors } from 'app-webtech-core';
import { trackGAPageview } from '../actions';

class PageTrackerContainer extends PureComponent {
  static propTypes = {
    pagePath: PropTypes.string.isRequired,
    gaTrackPageview: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { gaTrackPageview, pagePath } = this.props;
    if (pagePath) {
      gaTrackPageview();
    }
  }

  componentDidUpdate() {
    const { gaTrackPageview, pagePath } = this.props;
    if (pagePath) {
      gaTrackPageview();
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  pagePath: selectors.location.properties(state).pathname,
});

const mapDispatchToProps = {
  gaTrackPageview: trackGAPageview,
};

export const PageTracker = connect(mapStateToProps, mapDispatchToProps)(PageTrackerContainer);
